import { Cloud } from '@cast/shared-types';

export enum ConnectionChoice {
  cloudConnect = 'Connect your cloud',
  snapshot = 'Take a snapshot of your cloud',
  single = 'Onboard a single cluster manually',
}

export type ScriptState = {
  isLoading: boolean;
  hasError: boolean;
};

export type OnScriptStateChange = (state: ScriptState) => void;

export const CTA_LABELS: Record<ConnectionChoice, string> = {
  [ConnectionChoice.cloudConnect]: 'I ran the script',
  [ConnectionChoice.snapshot]: 'I ran the script',
  [ConnectionChoice.single]: 'I ran castctl',
};

export const PROVIDER_LABELS: Partial<Record<Cloud, string>> = {
  [Cloud.aws]: 'AWS',
  [Cloud.gcp]: 'GCP',
  [Cloud.azure]: 'Azure',
};

/** Snapshot onboarding is AWS-only for MVP; other providers show Coming soon. */
export const SNAPSHOT_COMING_SOON_PROVIDERS = [Cloud.gcp, Cloud.azure] as const;

export const ONBOARDING_STEP_COPY = {
  selectCloudProviderTitle: 'Select your cloud service provider',
  cloudConnectScriptDescription:
    "Run from the terminal with your CSP's cloud CLI configured. Cast AI will set up the required IAM roles automatically.",
} as const;

export const CONNECTING_CHECK_STEPS = [
  {
    title: 'Discovering clusters in region',
    description: 'Listing EKS / GKE / AKS clusters and node pools',
  },
  {
    title: 'Sampling 7 days of usage',
    description: 'Pulling CPU, memory and pod restart history',
  },
  {
    title: 'Computing available savings',
    description: 'Cross-referencing spot inventory and instance prices',
  },
] as const;

export type CheckStepStatus = 'pending' | 'active' | 'done';

export const CONNECTING_PHASE_COPY = {
  intro:
    'This usually takes under a minute. We’ll show you what’s happening behind the scenes.',
  backgroundNote:
    'We’ll keep working in the background. You can go to the console anytime — leaving won’t stop the connection.',
} as const;
